import categoryStore from '../../store/store';
import { action } from 'satcheljs/lib/legacy';
import getDefaultCategoryColorString from '../../utils/getDefaultCategoryColorString';

/**
 * Sets the initial state of new category view state
 */
export default action('setInitialNewCategoryViewState')(function setInitialNewCategoryViewState(
    newCategoryText?: string
) {
    categoryStore.categoryMenuViewState.newCategoryViewState = {
        categoryText: newCategoryText || '',
        selectedColorId: getDefaultCategoryColorString(),
        errorText: '',
        shouldFavorite: false,
    };
});
